import React from 'react';
import RouteMap from '../../components/RouteMap';
import TeamRoleList from './components/TeamRoleList';
import EditTeamRole from './components/EditTeamRole';
import CreateTeamRole from './components/CreateTeamRole';

const TeamRoles = ({
  match,
  role,
  user,
}) => (
  <RouteMap
    routes={[
      { path: `${match.url}/`, exact: true, component: TeamRoleList },
      { path: `${match.url}/:id/:type/edit`, exact: true, component: EditTeamRole },
      { path: `${match.url}/create`, exact: true, component: CreateTeamRole },
    ]}
    roleProp={role}
    user={user}
  />
);

export default TeamRoles;
